import React, { useEffect, useState } from "react";
import allApi from "../../../api/allApi";
import closeIcon from "../../../assets/images/close.svg";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import AllApi from "../../../api/allApi";
import Loader from "../common/Loader";
import DiscoverPopUp from "../common/DiscoverPopUp";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
// import SockJS from "sockjs-client";
// import Stomp from "stompjs";
import errorIcon from "../../../assets/images/error-2.png";
import { useLocalization } from "../localization/LocalizationContext";
import { useNetwork } from "../common/networkContext";
import NmsTableSearch, { searchRows } from "../common/NmsTableSearch";

function DeviceListing() {
  const navigate = useNavigate();
  const { localizationStrings } = useLocalization();
  const { selectedNetworkId, selectedLocation } = useNetwork();
  const networkId = selectedNetworkId?.id ?? 6001;
  const [deviceListings, setDeviceListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddDevice, setShowAddDevice] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [devicesPerPage] = useState(10);
  const [totalDevices, setTotalDevices] = useState(0);
  const [isSearchOpen, setIsSearchOpen] = useState({
    serialNumber: false,
    deviceName: false,
    protocolType: false,
    swVersion: false,
    ipAddress: false,
    macAddress: false,
    lastInform: false,
    health: false,
  });
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [individualCheckboxChecked, setIndividualCheckboxChecked] = useState(
    {}
  );
  const [newDeviceData, setNewDeviceData] = useState({
    deviceIP: "",
    deviceName: "",
    deviceMac: "",
    protocolType: "",
    deviceModel: "",
    isManaged: false,
    snmpID: "",
    snmpVer: "v2c",
    workingMode: "",
    isManageable: "2",
  });
  const [showPopUp, setShowPopUp] = useState(false);
  const [modalClosed, setModalClosed] = useState(false);
  const [showDiscoverPopUp, setShowDiscoverPopUp] = useState(false);
  const [discoveredDevice, setDiscoveredDevice] = useState(null);
  const [showProgress, setShowProgress] = useState(false);
  const [webSocket, setWebSocket] = useState(null);
  const [socketStatus, setSocketStatus] = useState("Connecting...");
  const [error, setError] = useState(null);
  const [show, setShow] = useState(false);
  const location = useLocation();
  const [filteredDevices, setFilteredDevices] = useState([]);
  const [deviceToDelete, setDeviceToDelete] = useState(null);
  const [devicesResponse, setDevicesResponse] = useState([]);
  const [gatewayId, setGatewayId] = useState();
  const [sortOrder, setSortOrder] = useState({
    gateway_name: "asc",
    organisation_name: "asc",
    site_name: "asc",
    publisher_topic: "asc",
    subscriber_topic: "asc",
    username: "asc",
    agent_mail: "asc",
    status: "asc",
  });
  const [editIndex, setEditIndex] = useState(null);
  const [deviceName, setDeviceName] = useState("");
  const [rebootDevice, setRebootDevice] = useState();
  const [resetDevice, setResetDevice] = useState();
  const [rebootTR069Device, setTR069RebootDevice] = useState();
  const [resetTR069Device, setTR069ResetDevice] = useState();
  const [showSnmpRebootSuccess, setShowSnmpRebootSuccess] = useState(false);
  const [showHttpSuccess, setShowHttpSuccess] = useState(false);
  const [showSnmpResetSuccess, setShowSnmpResetSuccess] = useState(false);
  const [showSNMPerror, setShowSNMPerror] = useState(false);
  const [snmpErrorMessage, setSnmpErrorMessage] = useState("");
  const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
  const [currentActionType, setCurrentActionType] = useState(null);
  const [tableQuery, setTableQuery] = useState("");
  // const { selectedNetworkId } = useNetwork();

  const actionSuccessMessageKeyMap = {
    reboot: "deviceRebootSuccessfully",
    reset: "deviceResetSuccessfully",
    //  rebootReset: 'deviceRebootedResetedSuccessfully',
  };

  // const [stompClient, setStompClient] = useState(null);

  // useEffect(() => {
  //   const socket = new SockJS('http://34.100.203.216:3000//websocket-endpoint');
  //   const stomp = Stomp.over(socket);
  //   stomp.connect({}, (frame) => {
  //     console.log('Connected to WebSocket');
  //     setStompClient(stomp);
  //     stomp.subscribe('/topic/request', (message) => {
  //       console.log('Received message:', message.body);
  //     });
  //   });

  //   return () => {
  //     socket.close();
  //   };
  // }, []);

  // const sendMessage = () => {
  //   if (stompClient) {
  //     const message = "Hello from client!";
  //     stompClient.send("/app/send", {}, message);
  //   } else {
  //     console.error("STOMP client is not connected.");
  //   }
  // };

  useEffect(() => {
    if (location.state && location.state.deviceStatus) {
      const deviceStatus = location.state.deviceStatus;
      setDevicesResponse(deviceStatus);
      setDeviceListings(deviceStatus);
      setTotalDevices(deviceStatus.length);
      setLoading(false);
    } else {
      getDeviceDetails(networkId);
    }
  }, [location.state,networkId]);

  useEffect(() => {
    if (
      (currentPage - 1) * devicesPerPage >= filteredDevices.length &&
      currentPage !== 1
    ) {
      setCurrentPage(1);
    }
  }, [filteredDevices]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const health = params.get("health");
    let next = deviceListings;
    if (health) {
      const key = health.toLowerCase();
      next = deviceListings.filter((device) => {
        const value = (device.health || "").toLowerCase();
        if (key === "awaiting") {
          return value && value !== "online" && value !== "offline";
        }
        return value === key;
      });
    }
    setFilteredDevices(
      searchRows(next, tableQuery, [
        "serialNumber",
        "deviceName",
        "deviceType",
        "protocolType",
        "softwareVersion",
        "ip",
        "macAddress",
        "managed_by_gateway",
        "networkName",
        "health",
        "lastInform",
      ])
    );
    setCurrentPage(1);
  }, [deviceListings, location.search, tableQuery]);

  async function getDeviceDetails(networkId) {
    try {
      setLoading(true);
      const api = new allApi();
      const devicesResponse = await api.getRequest(`api/devices/network?networkId=${networkId}`);

      if (devicesResponse) {
        setDevicesResponse(devicesResponse);
        setDeviceListings(devicesResponse);
        setTotalDevices(devicesResponse.length);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching device data:", error);
      setLoading(false);
    }
  }

  const handlePerticularGateway = async (managedByGateway) => {
    try {
      const api = new allApi();
      const response = await api.getRequest(`api/gateway/all`);
      if (response) {
        const gatewayDetails = response.find(
          (managedBy) => managedBy.gateway_name === managedByGateway
        );
        return gatewayDetails;
      }
    } catch (error) {
      console.error("Error fetching gateway data:", error);
    }
    return null;
  };

  const handlePerticularDevice = async (protocolType, deviceId, response) => {
    try {
      const api = new allApi();
      if (protocolType === "TR-069") {
        const tr069Response = await api.getRequest(
          `api/tr069/device/${deviceId}`
        );
        if (tr069Response) {
          navigate("/device-detail", {
            state: {
              protocolType: protocolType,
              deviceId: deviceId,
              deviceInfo: tr069Response,
            },
          });
        } else {
          console.error("Error fetching TR-069 device data.");
        }
      } else if (protocolType === "SNMP") {
        const managedByGateway = response?.managed_by_gateway || null;

        if (!managedByGateway) {
          console.error("Managed By Gateway is null or not defined.");
          navigate(`/device-snmp`, {
            state: {
              protocolType: protocolType,
              deviceId: deviceId,
              managed_by_gateway: "No Gateway",
              gateway_id: null,
            },
          });
          return;
        }

        const api = new allApi();
        const gatewayResponse = await api.getRequest(`api/gateway/all`);
        console.log("Gateway Response:", gatewayResponse);

        const gatewayDetails = gatewayResponse.find(
          (gateway) => gateway.gateway_name === managedByGateway
        );

        if (gatewayDetails) {
          navigate(`/device-snmp`, {
            state: {
              protocolType: protocolType,
              deviceId: deviceId,
              managed_by_gateway: managedByGateway,
              gateway_id: gatewayDetails.request_id,
            },
          });
        } else {
          console.error("Gateway details not found.");
        }
      } else if (protocolType === "http" || "ap") {
        const api = new allApi();
        const response = await api.getRequest(
          `api/device?protocolType=http&deviceId=${deviceId}`
        );
        if (response) {
          navigate(`/https-info`, { state: { deviceInfo: response } });
          console.log("deviceInfo", response);
        } else {
          console.error("Error fetching HTTPS device data.");
        }
      }
    } catch (error) {
      console.error("Error in handlePerticularDevice:", error);
    }
  };

  const handleDeleteDevice = async (devicesToDelete) => {
    try {
      const api = new allApi();
      const payload = devicesToDelete.map((device) => ({
        protocolType: device.protocolType,
        deviceId: device.deviceId,
      }));
      console.log("Deleting devices:", payload);

      const response = await api.deleteRequest("api/delete", payload);

      if (response) {
        const updatedDeviceListings = deviceListings.filter(
          (device) =>
            !devicesToDelete.some(
              (toDelete) =>
                toDelete.macAddress === device.macAddress ||
                toDelete.serialNumber === device.serialNumber
            )
        );

        setDeviceListings(updatedDeviceListings);
        setFilteredDevices(updatedDeviceListings);
        setShowDeleteSuccess(true);

        console.log("Devices deleted successfully");
      } else {
        console.error("Failed to delete devices");
      }
    } catch (error) {
      console.error("Error deleting devices:", error);
    }
  };

  const handleDeleteButtonClick = () => {
    const devicesToDelete = deviceListings.filter((device) => {
      if (device.protocolType === "TR-069") {
        return individualCheckboxChecked[device.serialNumber];
      } else {
        return individualCheckboxChecked[device.macAddress];
      }
    });
    handleDeleteDevice(devicesToDelete);
  };

  const isAnySelectedDeviceOnline = () => {
    return deviceListings.some((device) => {
      const isChecked =
        device.protocolType === "TR-069"
          ? individualCheckboxChecked[device.serialNumber]
          : individualCheckboxChecked[device.macAddress];

      return isChecked && device.health.toLowerCase() === "online";
    });
  };

  const handleReboot = async () => {
    try {
      const api = new AllApi();
      const devicesToReboot = deviceListings.filter(
        (device) => individualCheckboxChecked[device.macAddress]
      );
      const payload = devicesToReboot.map((device) => ({
        device_id: device.deviceId,
        action: "reboot",
      }));

      const response = await api.postRequest("api/snmp/reboot", "", payload);

      if (response) {
        console.log("Devices rebooted successfully");
        setShowSnmpRebootSuccess(true);
      } else {
        console.error("Failed to reboot devices");
      }
    } catch (error) {
      console.error("Error rebooting devices:", error);
    }
  };

  const handleSnmpCancel = () => {
    setShowSnmpRebootSuccess(false);
    setShowHttpSuccess(false);
    setShowSnmpResetSuccess(false);
    setShowSNMPerror(false);
  };

  const handleReset = async () => {
    try {
      const api = new AllApi();
      const devicesToReset = deviceListings.filter(
        (device) => individualCheckboxChecked[device.macAddress]
      );
      const payload = devicesToReset.map((device) => ({
        device_id: device.deviceId,
        action: "reset",
      }));

      const response = await api.postRequest("api/snmp/reset", "", payload);

      if (response) {
        console.log("Devices reset successfully");
        setShowSnmpResetSuccess(true);
      } else {
        console.error("Failed to reset devices");
      }
    } catch (error) {
      console.error("Error resetting devices:", error);
    }
  };

  const handleDeviceAction = async (actionType) => {
    try {
      const api = new allApi();
      const devicesToActOn = deviceListings.filter(
        (device) => individualCheckboxChecked[device.macAddress]
      );
      const payload = devicesToActOn.map((device) => ({
        deviceId: device.deviceId,
        action: actionType,
      }));

      if (payload.length === 0) {
        console.warn(`No devices selected for ${actionType}`);
        return;
      }

      const response = await api.postRequest(
        `api/http/${actionType}`,
        "",
        payload
      );

      if (response) {
        console.log(`Devices ${actionType}ed successfully`);
        setCurrentActionType(actionType);
        setShowHttpSuccess(true);
      } else {
        console.error(`Failed to ${actionType} devices:`, response);
      }
    } catch (error) {
      console.error(`Error ${actionType}ing devices:`, error);
    }
  };

  const handleTr069Reset = async () => {
    try {
      const api = new allApi();

      const selectedDevice = deviceListings.find(
        (device) =>
          device.protocolType === "TR-069" &&
          individualCheckboxChecked[device.serialNumber]
      );
      if (!selectedDevice) {
        console.warn("No TR-069 device selected.");
        return;
      }

      const payload = {
        id: selectedDevice.deviceId,
        action: "factoryReset",
      };

      const response = await api.postRequest("api/tr069/reset", "", payload);

      if (response && response.status === 200) {
        setShowSnmpResetSuccess(true);
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong while resetting the device.";
      setSnmpErrorMessage(errorMessage);
      setShowSNMPerror(true);
      console.error("Error during TR-069 reset:", error);
    }
  };

  const handleTr069Reboot = async () => {
    try {
      const api = new allApi();

      // Find a single TR-069 device selected for reboot
      const selectedDevice = deviceListings.find(
        (device) =>
          device.protocolType === "TR-069" &&
          individualCheckboxChecked[device.serialNumber]
      );

      if (!selectedDevice) {
        console.warn("No TR-069 device selected.");
        return;
      }

      // Payload should be a single object
      const payload = {
        id: selectedDevice.deviceId,
        action: "reboot",
      };

      const response = await api.postRequest("api/tr069/reboot", "", payload);

      if (response && response.status === 200) {
        setShowSnmpResetSuccess(true);
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong while rebooting the device.";
      setSnmpErrorMessage(errorMessage);
      setShowSNMPerror(true);
    }
  };

  const addDeviceToListing = async (device) => {
    try {
      setShowProgress(true);
      setDeviceListings((prevDeviceListings) => [
        ...prevDeviceListings,
        device,
      ]);
      await new Promise((resolve) => setTimeout(resolve, 3000));
      setShowProgress(false);
    } catch (error) {
      console.error("Error adding new device:", error);
    }
  };

  const handleAddDeviceToListing = async () => {};

  const handleSaveDiscover = async () => {
    try {
      setNewDeviceData(discoveredDevice);
      handleCloseAddDeviceSlider();
      setShowPopUp(true);
    } catch (error) {
      console.error("Error adding discovered device:", error);
    }
  };

  const handleCloseAddDeviceSlider = () => {
    setShowAddDevice(false);
  };

  const handleClose = () => {
    setShowPopUp(false);
    setModalClosed(true);
  };

  const handleAddButtonClick = () => {
    setShowDiscoverPopUp(true);
  };
  const handleDiscoverClose = () => {
    setShowDiscoverPopUp(false);
  };

  const formatTime = (lastInform) => {
    const formattedDate = moment(lastInform, "DD-MM-YYYY HH:mm:ss").format(
      "MM/DD/YYYY, HH:mm:ss"
    );
    const now = moment();
    const informTime = moment(formattedDate);
    const duration = moment.duration(now.diff(informTime));

    const minutes = duration.minutes();
    const seconds = duration.seconds();

    return `${formattedDate} (${minutes} minutes ${seconds} seconds ago)`;
  };

  const totalFilteredDevices = filteredDevices.length;

  // Reset current page if it exceeds available pages
  if (
    (currentPage - 1) * devicesPerPage >= totalFilteredDevices &&
    currentPage !== 1
  ) {
    setCurrentPage(1);
  }

  const indexOfLastDevice = currentPage * devicesPerPage;
  const indexOfFirstDevice = indexOfLastDevice - devicesPerPage;

  const currentDevices = filteredDevices.slice(
    indexOfFirstDevice,
    indexOfLastDevice
  );

  const handleSelectAllCheckbox = () => {
    // setSelectAllChecked((prev) => !prev);
    const newCheckboxState = {};
    deviceListings.forEach((device) => {
      if (device.protocolType === "TR-069") {
        newCheckboxState[device.serialNumber] = !selectAllChecked;
      } else {
        newCheckboxState[device.macAddress] = !selectAllChecked;
      }
    });

    setSelectAllChecked((prev) => !prev);
    setIndividualCheckboxChecked(newCheckboxState);
  };

  const handleIndividualCheckboxChange = (device) => {
    const key =
      device.protocolType === "TR-069"
        ? device.serialNumber
        : device.macAddress;

    setIndividualCheckboxChecked((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewDeviceData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSearch = (e) => {
    const { name, value } = e.target;

    if (value.trim() === "") {
      setFilteredDevices(deviceListings);
    } else {
      const filtered = deviceListings.filter((device) =>
        device[name]?.toString().toLowerCase().includes(value.toLowerCase())
      );
      setFilteredDevices(filtered);
    }

    setCurrentPage(1);
  };

  const handleSearchBox = (header) => {
    Object.keys(isSearchOpen).find((key) => {
      if (key == header) {
        isSearchOpen[key] = !isSearchOpen[key];
      } else {
        isSearchOpen[key] = false;
      }
    });
    setIsSearchOpen({ ...isSearchOpen });
  };

  const handleDashboardButtonClick = (device) => {
    const { protocolType, deviceId } = device;

    if (protocolType === "SNMP") {
      navigate(`/device-dashboard`, { state: { deviceId } });
    } else if (protocolType === "TR-069") {
      navigate(`/tr069-Dashboard`, { state: { deviceId } });
    } else if (protocolType === "http") {
      navigate(`/http-dashboard`, { state: { deviceId } });
    } else {
      console.error("Unknown protocol type:", protocolType);
    }
  };

  const totalPages = Math.ceil(totalFilteredDevices / devicesPerPage);
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  const handleFirstPage = () => {
    setCurrentPage(1);
  };
  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };
  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  const handleSortChange = (field) => {
    const newOrder = sortOrder[field] === "asc" ? "desc" : "asc";
    const sortedDevices = [...filteredDevices].sort((a, b) => {
      const aValue = a[field] ? a[field].toString().toLowerCase() : "";
      const bValue = b[field] ? b[field].toString().toLowerCase() : "";

      if (newOrder === "asc") {
        return aValue.localeCompare(bValue);
      } else {
        return bValue.localeCompare(aValue);
      }
    });

    setFilteredDevices(sortedDevices);
    setSortOrder((prevState) => ({
      ...prevState,
      [field]: newOrder,
    }));
  };

  const renameDevice = async (protocolType, deviceId, newName) => {
    try {
      if (!deviceId) {
        console.error("Device ID is undefined. Cannot update device name.");
        return false;
      }

      const api = new allApi();
      let response;

      const payload =
        protocolType === "SNMP"
          ? { device_name: newName }
          : { deviceName: newName };
      if (protocolType === "SNMP") {
        response = await api.putRequest(`api/snmp/update/${deviceId}`, payload);
      } else if (protocolType === "http") {
        response = await api.putRequest(
          `api/http/deviceName/${deviceId}`,
          payload
        );
      }

      if (response) {
        return true;
      }
    } catch (error) {
      console.error("API call failed:", error);
      return false;
    }
  };

  const handleSaveDeviceName = async (index) => {
    const selectedDevice = currentDevices[index];
    const { protocolType, deviceId } = selectedDevice;
    const isUpdated = await renameDevice(protocolType, deviceId, deviceName);
    if (isUpdated) {
      setEditIndex(null);
      await getDeviceDetails();
    }
  };

  const handleDoubleClick = (index, currentName) => {
    const selectedDevice = currentDevices[index];
    const { deviceId } = selectedDevice;

    if (!deviceId) {
      console.error("Device ID is missing for the selected device.");
      return;
    }

    setEditIndex(index);
    setDeviceName(currentName);
  };

  const handleDeviceNameChange = (e) => {
    setDeviceName(e.target.value);
  };

  const handleSettingsClick = (device) => {
    const { protocolType, deviceType, deviceId, health } = device;
    if (protocolType === "SNMP") {
      navigate("/device-settings", { state: { deviceId, health } });
    } else if (protocolType === "http") {
      if (deviceType === "AP") {
        navigate("/wifi-config");
      } else {
        navigate("/wired-config");
      }
    } else if (protocolType === "TR-069") {
      navigate("/tr069-config", { state: { deviceId } });
    }
  };

  // const handleDownloadDevice = async (device) => {
  //   try {
  //     const serialNo = device.serialNumber;
  //     if (!serialNo) {
  //       setSnmpErrorMessage("Serial number not available for this device.");
  //       setShowSNMPerror(true);
  //       return;
  //     }

  //     const api = new allApi();
  //     const response = await api.getDownloadRequest(
  //       `api/crash/crash-logs?serialNo=${serialNo}`
  //     );

  //     if (!response.ok) {
  //       // Try to extract error message from API response
  //       let errorMsg = "Failed to download crash logs.";
  //       try {
  //         const errorData = await response.json();
  //         if (errorData && errorData.error) {
  //           errorMsg = errorData.error;
  //         } else if (errorData && errorData.message) {
  //           errorMsg = errorData.message;
  //         }
  //       } catch (e) {
  //         // If not JSON, keep default errorMsg
  //       }
  //       setSnmpErrorMessage(errorMsg);
  //       setShowSNMPerror(true);
  //       return;
  //     }

  //     const blob = await response.blob();
  //     let filename = `${serialNo}_crash_logs.zip`;
  //     const disposition = response.headers.get("Content-Disposition");
  //     if (disposition && disposition.indexOf("filename=") !== -1) {
  //       filename = disposition.split("filename=")[1].replace(/"/g, "");
  //     }

  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = filename;
  //     document.body.appendChild(a);
  //     a.click();
  //     a.remove();
  //     window.URL.revokeObjectURL(url);

  //     setShowSnmpRebootSuccess(true);
  //   } catch (error) {
  //     setSnmpErrorMessage(error?.message);
  //     setShowSNMPerror(true);
  //     console.error(error);
  //   }
  // };

  const disableReboot = (health) => health != "Online";

  const successhandleClose = () => setShow(false);
  const successhandleShow = () => setShow(true);

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="inc-card ch-100">
          <div className="inc-card-title">
            <h3>{localizationStrings?.devices}</h3>
            <div className="inc-card-button">
              <NmsTableSearch
                value={tableQuery}
                onChange={setTableQuery}
                placeholder={localizationStrings?.search || "Search devices"}
              />
              <button
                className="text-btn primary-btn"
                onClick={() => {
                  handleAddButtonClick();
                  navigate("/device-discovery");
                }}
              >
                <i className="fa fa-plus" aria-hidden="true"></i>
                {localizationStrings?.add}
              </button>
              <button
                className="text-btn"
                title={
                  Object.values(individualCheckboxChecked).some(
                    (isChecked) => isChecked
                  )
                    ? ""
                    : localizationStrings?.rebootDeviceSelect
                }
                data-bs-toggle="modal"
                data-bs-target="#noDeviceReboot"
                // onClick={() => {
                //   const tr069Selected = deviceListings.some(
                //     (device) =>
                //       individualCheckboxChecked[device.serialNumber] &&
                //       device.protocolType === "TR-069"
                //   );

                //   const snmpSelected = deviceListings.some(
                //     (device) =>
                //       individualCheckboxChecked[device.macAddress] &&
                //       device.protocolType === "SNMP"
                //   );

                //   if (tr069Selected) handleTr069Reboot();
                //   if (snmpSelected) handleReboot();
                // }}
                disabled={
                  !Object.values(individualCheckboxChecked).some(
                    (isChecked) => isChecked
                  ) || !isAnySelectedDeviceOnline()
                }
              >
                {localizationStrings?.reboot}
              </button>
              <button
                className="text-btn"
                title={
                  Object.values(individualCheckboxChecked).some(
                    (isChecked) => isChecked
                  )
                    ? ""
                    : localizationStrings?.resetDeviceSelect
                }
                data-bs-toggle="modal"
                data-bs-target="#noDeviceReset"
                // onClick={() => {
                //   const tr069Selected = deviceListings.some(
                //     (device) =>
                //       individualCheckboxChecked[device.serialNumber] &&
                //       device.protocolType === "TR-069"
                //   );

                //   const snmpSelected = deviceListings.some(
                //     (device) =>
                //       individualCheckboxChecked[device.macAddress] &&
                //       device.protocolType === "SNMP"
                //   );

                //   if (tr069Selected) handleTr069Reset();
                //   if (snmpSelected) handleReset();
                // }}
                disabled={
                  !Object.values(individualCheckboxChecked).some(
                    (isChecked) => isChecked
                  ) || !isAnySelectedDeviceOnline()
                }
              >
                {localizationStrings?.reset}
              </button>

              <button
                className="icon-btn"
                title="Refresh"
                onClick={() => getDeviceDetails(networkId)}
              >
                <i className="fa fa-refresh" aria-hidden="true"></i>
              </button>
              {/* <button className="icon-btn" title="Push">
                <i className="fa fa-upload" aria-hidden="true"></i>
              </button> */}
              <button
                className="icon-btn"
                title={
                  Object.values(individualCheckboxChecked).some(
                    (isChecked) => isChecked
                  )
                    ? ""
                    : localizationStrings?.deleteDeviceSelect
                }
                data-bs-toggle="modal"
                data-bs-target="#noDeviceSelectedPopup"
                disabled={Object.values(individualCheckboxChecked).every(
                  (isChecked) => !isChecked
                )}
                //onClick={handleDeleteButtonClick}
              >
                <i className="fa fa-trash" aria-hidden="true"></i>
              </button>

              {/* <button className="icon-btn" title="Download">
                <i className="fa fa-download" aria-hidden="true"></i>
              </button> */}
              {/* <button className="icon-btn" title="Tag">
                <i className="fa fa-tags" aria-hidden="true"></i>
              </button> */}
              {/* <span
                className="icon-btn dropdown"
                title="Filter"
                id="deviceFilter"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa fa-filter" aria-hidden="true"></i>
                <div
                  className="dropdown-menu dropdown-menu-end device-filter"
                  aria-labelledby="deviceFilter"
                >
                  <div className="filter-title">
                    <span>Filter</span>
                    <a href="#">Clear</a>
                  </div>
                  <div className="filter-body">
                    <input type="text" className="cal-input" />
                    <h4>States</h4>
                    <ul>
                      <li>
                        <input type="radio" name="radio" /> All
                      </li>
                      <li>
                        <input type="radio" name="radio" /> Online
                      </li>
                      <li>
                        <input type="radio" name="radio" /> Offline
                      </li>
                    </ul>
                  </div>
                  <div className="filter-button">
                    <button className="lineBtn">Cancel</button>
                    <button className="fillBtn">Apply</button>
                  </div>
                </div>
              </span> */}
            </div>
          </div>
          <Modal
            show={showDeleteSuccess}
            onHide={() => setShowDeleteSuccess(false)}
            centered
            className="inc-alert index-2000"
          >
            <span className="success-icon">
              <i className="icon done"></i>
            </span>
            <h3>{localizationStrings?.success}</h3>
            <p>{localizationStrings?.deviceDeleted}</p>
            <Button onClick={() => setShowDeleteSuccess(false)}>
              {localizationStrings?.ok}
            </Button>
          </Modal>

          <div className="inc-card-body">
            {loading ? (
              <Loader />
            ) : (
              <div>
                <div className="inc-card-table">
                  <table className="full-table">
                    <thead>
                      <tr>
                        <th>
                          <label className="checkbox">
                            <input
                              type="checkbox"
                              checked={selectAllChecked}
                              onChange={() => handleSelectAllCheckbox()}
                            />{" "}
                            <span className="indicator"></span>
                          </label>
                        </th>
                        <th className="inc-th-sort" onClick={() => handleSortChange("serialNumber")}>
                          {localizationStrings?.serialNumber}
                          <i className="fa fa-sort" aria-hidden="true" />
                        </th>
                        <th className="inc-th-sort" onClick={() => handleSortChange("deviceName")}>
                          {localizationStrings?.deviceName}
                          <i className="fa fa-sort" aria-hidden="true" />
                        </th>
                        <th className="inc-th-sort" onClick={() => handleSortChange("deviceType")}>
                          {localizationStrings?.deviceType}
                          <i className="fa fa-sort" aria-hidden="true" />
                        </th>
                        <th className="inc-th-sort" onClick={() => handleSortChange("protocolType")}>
                          {localizationStrings?.protocolType}
                          <i className="fa fa-sort" aria-hidden="true" />
                        </th>
                        <th className="inc-th-sort" onClick={() => handleSortChange("softwareVersion")}>
                          {localizationStrings?.firmwareVersion}
                          <i className="fa fa-sort" aria-hidden="true" />
                        </th>
                        <th className="inc-th-sort" onClick={() => handleSortChange("ip")}>
                          {localizationStrings?.ipAddress}
                          <i className="fa fa-sort" aria-hidden="true" />
                        </th>
                        <th className="inc-th-sort" onClick={() => handleSortChange("macAddress")}>
                          {localizationStrings?.macAddress}
                          <i className="fa fa-sort" aria-hidden="true" />
                        </th>
                        <th className="inc-th-sort" onClick={() => handleSortChange("managed_by_gateway")}>
                          {localizationStrings?.edgeServer}
                          <i className="fa fa-sort" aria-hidden="true" />
                        </th>
                        <th className="inc-th-sort" onClick={() => handleSortChange("networkName")}>
                          {localizationStrings?.networkName}
                          <i className="fa fa-sort" aria-hidden="true" />
                        </th>
                        <th className="inc-th-sort" onClick={() => handleSortChange("lastInform")}>
                          {localizationStrings?.lastInform}
                          <i className="fa fa-sort" aria-hidden="true" />
                        </th>
                        <th className="inc-th-sort" onClick={() => handleSortChange("health")}>
                          {localizationStrings?.health}
                          <i className="fa fa-sort" aria-hidden="true" />
                        </th>
                        <th>{localizationStrings?.action}</th>
                      </tr>
                      <tr className="search-border">
                        <td></td>
                        <td>
                          <input
                            className="searchBox smallWidth"
                            type="text"
                            name="serialNumber"
                            onKeyUp={handleSearch}
                          />
                          <i
                            className={`fa ${
                              sortOrder.serialNumber === "asc"
                                ? "fa fa-sort-amount-desc"
                                : "fa fa-sort-amount-asc"
                            }`}
                            onClick={() => handleSortChange("serialNumber")}
                            aria-hidden="true"
                          ></i>
                        </td>
                        <td>
                          <input
                            className="searchBox smallWidth"
                            type="text"
                            name="deviceName"
                            onKeyUp={(e) => handleSearch(e)}
                          />{" "}
                          <i
                            className={`fa ${
                              sortOrder.deviceName === "asc"
                                ? "fa fa-sort-amount-desc"
                                : "fa fa-sort-amount-asc"
                            }`}
                            onClick={() => handleSortChange("deviceName")}
                            aria-hidden="true"
                          ></i>
                        </td>
                        <td>
                          <input
                            className="searchBox smallWidth"
                            type="text"
                            name="deviceType"
                            onKeyUp={(e) => handleSearch(e)}
                          />{" "}
                          <i
                            className={`fa ${
                              sortOrder.deviceType === "asc"
                                ? "fa fa-sort-amount-desc"
                                : "fa fa-sort-amount-asc"
                            }`}
                            onClick={() => handleSortChange("deviceType")}
                            aria-hidden="true"
                          ></i>
                        </td>
                        <td>
                          <input
                            className="searchBox smallWidth"
                            type="text"
                            name="protocolType"
                            onKeyUp={(e) => handleSearch(e)}
                          />{" "}
                          <i
                            className={`fa ${
                              sortOrder.protocolType === "asc"
                                ? "fa fa-sort-amount-desc"
                                : "fa fa-sort-amount-asc"
                            }`}
                            onClick={() => handleSortChange("protocolType")}
                            aria-hidden="true"
                          ></i>
                        </td>
                        <td>
                          <input
                            className="searchBox smallWidth"
                            type="text"
                            name="softwareVersion"
                            onKeyUp={(e) => handleSearch(e)}
                          />
                          <i
                            className={`fa ${
                              sortOrder.softwareVersion === "asc"
                                ? "fa fa-sort-amount-desc"
                                : "fa fa-sort-amount-asc"
                            }`}
                            onClick={() => handleSortChange("softwareVersion")}
                            aria-hidden="true"
                          ></i>
                        </td>
                        <td>
                          <input
                            className="searchBox smallWidth"
                            type="text"
                            name="ip"
                            onKeyUp={(e) => handleSearch(e)}
                          />
                          <i
                            className={`fa ${
                              sortOrder.ip === "asc"
                                ? "fa fa-sort-amount-desc"
                                : "fa fa-sort-amount-asc"
                            }`}
                            onClick={() => handleSortChange("ip")}
                            aria-hidden="true"
                          ></i>
                        </td>
                        <td>
                          <input
                            className="searchBox smallWidth"
                            type="text"
                            name="macAddress"
                            onKeyUp={(e) => handleSearch(e)}
                          />
                          <i
                            className={`fa ${
                              sortOrder.macAddress === "asc"
                                ? "fa fa-sort-amount-desc"
                                : "fa fa-sort-amount-asc"
                            }`}
                            onClick={() => handleSortChange("macAddress")}
                            aria-hidden="true"
                          ></i>
                        </td>
                        <td>
                          <input
                            className="searchBox smallWidth"
                            type="text"
                            name="managed_by_gateway"
                            onKeyUp={handleSearch}
                          />
                          <i
                            className={`fa ${
                              sortOrder.managed_by_gateway === "asc"
                                ? "fa fa-sort-amount-desc"
                                : "fa fa-sort-amount-asc"
                            }`}
                            onClick={() =>
                              handleSortChange("managed_by_gateway")
                            }
                            aria-hidden="true"
                          ></i>
                        </td>
                        <td>
                          <input
                            className="searchBox smallWidth"
                            type="text"
                            name="networkName"
                            onKeyUp={handleSearch}
                          />
                          <i
                            className={`fa ${
                              sortOrder.networkName === "asc"
                                ? "fa fa-sort-amount-desc"
                                : "fa fa-sort-amount-asc"
                            }`}
                            onClick={() => handleSortChange("networkName")}
                            aria-hidden="true"
                          ></i>
                        </td>
                        <td>
                          <input
                            className="searchBox smallWidth"
                            type="text"
                            name="lastInform"
                            onKeyUp={(e) => handleSearch(e)}
                          />
                          <i
                            className={`fa ${
                              sortOrder.lastInform === "asc"
                                ? "fa fa-sort-amount-desc"
                                : "fa fa-sort-amount-asc"
                            }`}
                            onClick={() => handleSortChange("lastInform")}
                            aria-hidden="true"
                          ></i>
                        </td>
                        <td>
                          <input
                            className="searchBox smallWidth"
                            type="text"
                            name="health"
                            onKeyUp={(e) => handleSearch(e)}
                          />
                          <i
                            className={`fa ${
                              sortOrder.health === "asc"
                                ? "fa fa-sort-amount-desc"
                                : "fa fa-sort-amount-asc"
                            }`}
                            onClick={() => handleSortChange("health")}
                            aria-hidden="true"
                          ></i>
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredDevices && filteredDevices.length > 0 ? (
                        currentDevices.map((device, index) => (
                          <tr key={index}>
                            <td>
                              <label className="checkbox">
                                <input
                                  type="checkbox"
                                  checked={
                                    device.protocolType === "TR-069"
                                      ? individualCheckboxChecked[
                                          device.serialNumber
                                        ] || false
                                      : individualCheckboxChecked[
                                          device.macAddress
                                        ] || false
                                  }
                                  onChange={() =>
                                    handleIndividualCheckboxChange(device)
                                  }
                                />

                                <span className="indicator"></span>
                              </label>
                            </td>
                            <td>
                              <span
                                className="device-info0 underline"
                                onClick={() =>
                                  handlePerticularDevice(
                                    device.protocolType,
                                    device.deviceId,
                                    device
                                  )
                                }
                              >
                                {device.serialNumber || "N/A"}
                              </span>
                            </td>
                            <td
                              onDoubleClick={() =>
                                handleDoubleClick(index, device.deviceName)
                              }
                            >
                              {editIndex === index ? (
                                <div className="double-click-box">
                                  <input
                                    type="text"
                                    value={deviceName}
                                    onChange={handleDeviceNameChange}
                                    onKeyUp={(e) => {
                                      if (e.key === "Enter") {
                                        handleSaveDeviceName(index);
                                      }
                                    }}
                                    autoFocus
                                  />
                                  <i
                                    className="fa fa-times"
                                    aria-hidden="true"
                                    onClick={() => setEditIndex(null)}
                                  ></i>
                                  <i
                                    className="fa fa-check"
                                    aria-hidden="true"
                                    onClick={() => handleSaveDeviceName(index)}
                                  ></i>
                                </div>
                              ) : (
                                device.deviceName || "N/A"
                              )}
                            </td>
                            <td>{device.deviceType || "N/A"}</td>
                            <td>
                              {device?.protocolType?.toUpperCase() || "-"}
                            </td>
                            <td>{device.softwareVersion || "N/A"}</td>
                            <td>{device.ip || "N/A"}</td>
                            <td>{device.macAddress || "N/A"}</td>
                            <td>{device.managed_by_gateway || "N/A"}</td>
                            <td>{device.networkName || "N/A"}</td>
                            <td>{device.lastInform || "N/A"}</td>
                            <td>
                              <span
                                className={
                                  "d-status " +
                                  (device?.health?.toLowerCase() === "offline"
                                    ? "offline"
                                    : device?.health?.toLowerCase() === "online"
                                    ? "online"
                                    : "awaitingConnection")
                                }
                              >
                                {device.health || "N/A"}
                              </span>{" "}
                            </td>
                            <td>
                              <div className="button-group">
                                <button
                                  title="Dashboard"
                                  onClick={() =>
                                    handleDashboardButtonClick(device)
                                  }
                                >
                                  <i
                                    className="fa fa-th-large"
                                    aria-hidden="true"
                                  ></i>
                                </button>

                                <button
                                  title="Settings"
                                  onClick={() => handleSettingsClick(device)}
                                >
                                  <i
                                    className="fa fa-cog"
                                    aria-hidden="true"
                                  ></i>
                                </button>

                                {/* <button
                                  title="Crash Logs"
                                  onClick={() => handleDownloadDevice(device)}
                                >
                                  <i
                                    className="fa fa-download"
                                    aria-hidden="true"
                                  ></i>
                                </button> */}

                                <button
                                  title="Delete"
                                  data-bs-toggle="modal"
                                  data-bs-target="#noDeviceSelectedPopup"
                                  disabled={
                                    !individualCheckboxChecked[
                                      device.macAddress
                                    ]
                                  }
                                  onClick={() =>
                                    handleDeleteDevice({
                                      protocolType: device.protocolType,
                                      deviceId: device.deviceId,
                                    })
                                  }
                                >
                                  <i
                                    className="fa fa-trash"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" style={{ textAlign: "center" }}>
                            {localizationStrings?.noData}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
          <div className="pagination-container">
            {totalFilteredDevices > 0 ? (
              <>
                <div className="pagination-info">
                  <p>
                    {localizationStrings?.showing} {indexOfFirstDevice + 1}
                    {"-"}
                    {Math.min(
                      currentPage * devicesPerPage,
                      totalFilteredDevices
                    )}{" "}
                    {localizationStrings?.of} {totalFilteredDevices}{" "}
                    {localizationStrings?.records}
                  </p>
                </div>
                <div className="pagination">
                  <button
                    onClick={handleFirstPage}
                    disabled={currentPage === 1}
                  >
                    {localizationStrings?.firstPage}
                  </button>
                  <button onClick={handlePrevPage} disabled={currentPage === 1}>
                    {localizationStrings?.previous}
                  </button>
                  {[...Array(Math.min(totalPages, 10)).keys()].map((page) => (
                    <button
                      key={page}
                      onClick={() => handlePageClick(page + 1)}
                      className={currentPage === page + 1 ? "active" : ""}
                    >
                      {page + 1}
                    </button>
                  ))}
                  <button
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  >
                    {localizationStrings?.next}
                  </button>
                  <button
                    onClick={handleLastPage}
                    disabled={currentPage === totalPages}
                  >
                    {localizationStrings?.lastPage}
                  </button>
                </div>
              </>
            ) : (
              <div>
                <p>{localizationStrings?.noRecords}</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <DiscoverPopUp
        showPopUp={showDiscoverPopUp}
        handleClose={handleDiscoverClose}
        headerMessage1="Onboard Device"
        handleSaveDiscover={handleSaveDiscover}
        addDeviceToListing={addDeviceToListing}
        newDeviceData={newDeviceData}
        handleInputChange={handleInputChange}
        closeIcon={closeIcon}
        getDeviceDetails={getDeviceDetails}
        setDiscoveredDevice={setDiscoveredDevice}
      />

      <div
        className={`modal fade`}
        id="noDeviceSelectedPopup"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="customModal confirm-modal">
          <div className="modal-dialog modal-dialog-centered small">
            <div className="modal-content inc-modal">
              <div className="modal-body error-msg">
                <img src={errorIcon} alt="error" />
                <p>{localizationStrings?.removeInfo}</p>
                <h3>{localizationStrings?.deleteConfirmation}</h3>
                <div className="modal-footer">
                  <button
                    className="text-btn secondary-btn"
                    data-bs-dismiss="modal"
                  >
                    {localizationStrings?.no}
                  </button>
                  <button
                    className="text-btn primary-btn"
                    data-bs-dismiss="modal"
                    onClick={() => handleDeleteButtonClick()}
                  >
                    {localizationStrings?.yes}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade`}
        id="noDeviceReboot"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content inc-modal">
            <div className="modal-body success-msg">
              <img src={errorIcon} alt="error" />
              <p>{localizationStrings?.rebootConfirmation}?</p>
              <button
                className="text-btn primary-btn"
                data-bs-dismiss="modal"
                onClick={() => {
                  const selectedTr069 = deviceListings.find(
                    (device) =>
                      individualCheckboxChecked[device.serialNumber] &&
                      device.protocolType === "TR-069"
                  );

                  const selectedSnmp = deviceListings.find(
                    (device) =>
                      individualCheckboxChecked[device.macAddress] &&
                      device.protocolType === "SNMP"
                  );

                  if (selectedTr069) {
                    handleTr069Reboot();
                  } else if (selectedSnmp) {
                    handleReboot();
                  } else {
                    handleDeviceAction("reboot");
                  }
                }}
              >
                {localizationStrings?.yes}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade`}
        id="noDeviceReset"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content inc-modal">
            <div className="modal-body success-msg">
              <img src={errorIcon} alt="error" />
              <p>{localizationStrings?.resetConfirmation}?</p>
              <button
                className="text-btn primary-btn"
                data-bs-dismiss="modal"
                onClick={() => {
                  const selectedTr069 = deviceListings.find(
                    (device) =>
                      individualCheckboxChecked[device.serialNumber] &&
                      device.protocolType === "TR-069"
                  );

                  const selectedSnmp = deviceListings.find(
                    (device) =>
                      individualCheckboxChecked[device.macAddress] &&
                      device.protocolType === "SNMP"
                  );

                  if (selectedTr069) {
                    handleTr069Reset();
                  } else if (selectedSnmp) {
                    handleReset();
                  } else {
                    handleDeviceAction("reset");
                  }
                }}
              >
                {localizationStrings?.yes}
              </button>
            </div>
          </div>
        </div>
        <Modal
          show={showSnmpRebootSuccess}
          onHide={handleSnmpCancel}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="inc-alert index-2000"
        >
          <span className="success-icon">
            <i className="icon done"></i>
          </span>
          <h3>{localizationStrings?.success}</h3>
          <p>{localizationStrings?.deviceRebootedSuccessfully}</p>
          <Button onClick={handleSnmpCancel}>{localizationStrings?.ok}</Button>
        </Modal>
        <Modal
          show={showHttpSuccess}
          onHide={handleSnmpCancel}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="inc-alert index-2000"
        >
          <span className="success-icon">
            <i className="icon done"></i>
          </span>
          <h3>{localizationStrings?.success}</h3>
          <p>
            {
              localizationStrings?.[
                actionSuccessMessageKeyMap[currentActionType]
              ]
            }
          </p>
          <Button onClick={handleSnmpCancel}>{localizationStrings.ok}</Button>
        </Modal>
        <Modal
          show={showSnmpResetSuccess}
          onHide={handleSnmpCancel}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="inc-alert index-2000"
        >
          <span className="success-icon">
            <i className="icon done"></i>
          </span>
          <h3>{localizationStrings?.success}</h3>
          <p>{localizationStrings?.deviceResetedSuccessfully}</p>
          <Button onClick={handleSnmpCancel}>{localizationStrings?.ok}</Button>
        </Modal>
        <Modal
          show={showSNMPerror}
          onHide={() => handleSnmpCancel(false)}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="inc-alert index-2000"
        >
          <span className="error-icon">
            <img src={errorIcon} alt="Error" />
          </span>
          <h3>{localizationStrings?.error}</h3>
          <p>{snmpErrorMessage}</p>
          <Button onClick={handleSnmpCancel}>{localizationStrings?.ok}</Button>
        </Modal>
      </div>
    </div>
  );
}

export default DeviceListing;
